import { render, staticRenderFns } from "./CommunicationRecords.vue?vue&type=template&id=5ff5ce6e&scoped=true&"
import script from "./CommunicationRecords.vue?vue&type=script&lang=js&"
export * from "./CommunicationRecords.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationRecords.vue?vue&type=style&index=0&id=5ff5ce6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5ce6e",
  null
  
)

export default component.exports